import { render, staticRenderFns } from "./IconBtnMobile.vue?vue&type=template&id=6c742886"
import script from "./IconBtnMobile.vue?vue&type=script&lang=js"
export * from "./IconBtnMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports